module.exports = __webpack_public_path__ + "static/media/menu-icon.28d3734f.svg";